{
  "common": {
    "loading": "Cargando",
    "enabled": "Habilitado",
    "disabled": "Deshabilitado",
    "learnMore": "Aprende Más",
    "edit": "Editar",
    "view": "Ver",
    "pleaseWait": "Por favor espera...",
    "done": "Listo"
  },
  "billing-upgrade-cta-banner": {
    "billedTrialEnd": "Se te cobrará <1>{{billedAmount}}</1> al final de la prueba. ",
    "completeBilling": "Añade tus datos de pago para empezar tu suscripción.",
    "planTrial": "Estás en la prueba de {{plan}}. ",
    "remainingTrial": "Te faltan <1>{{remaining}}</1> para seguir probando el plan {{plan}}. ",
    "startSubscription": "Empezar suscripción"
  },
  "campaigns": {
    "common": {
      "title": "Campañas",
      "createCampaign": "Crear Campaña"
    },
    "campaignForm": {
      "cancel": "Cancelar",
      "color": "Color",
      "createTitle": "Crear Campaña",
      "editTitle": "Editar Campaña",
      "name": "Nombre",
      "notice1": "El contenido de la campaña es visible para todos los miembros de tu organización. ",
      "tagNameErrorText": "Esta {{entity}} ya existe.",
      "tagLengthErrorText": "El nombre debe tener menos de 100 caracteres.",
      "notice2": "Descubre más",
      "notice3": " en nuestro FAQ.",
      "placeholder": "Nombre de la campaña",
      "saveCampaign": "Guardar Campaña"
    },
    "deleteCampaignModal": {
      "boldSubtext": "No podremos guardar o analizar ninguno de los datos de tu campaña.",
      "cancel": "Cancelar",
      "delete": "Sí, borrar campaña",
      "loading": "Borrando...",
      "subtext": " Si también quieres parar de enviar las publicaciones de tu campaña, por favor, borra cada una individualmente.",
      "title": "Estás seguro de querer borrar tu campaña,"
    },
    "emptyState": {
      "createCampaign": "Crear una Campaña",
      "imageTag": "Ejemplo de campaña con múltiples publicaciones programadas.",
      "item1": "Contruye campañas a través de las redes sociales.",
      "item2": "Observa cómo funcionan entre sí en tu programación.",
      "item3": "Revisa el rendimiento de la campaña y alcanza tus objetivos.",
      "learnMore": "Aprende Más",
      "subtext": "Haz seguimiento de las campañas multicanal y crea una combinación saludable de contenido en las redes sociales",
      "title": "Obtén una imagen más clara de tu estrategia en redes sociales"
    },
    "viewCampaign": {
      "allPostsSent": {
        "createCampaign": "Crear Nueva Campaña",
        "createPost": "Crear Publicación",
        "subtitle": "Todo el contenido programado para esta campaña ha sido publicado.",
        "title": "¡Bien, todo enviado!",
        "viewReport": "Ver Análisis"
      },
      "createPost": "Crear Publicación",
      "deleteCampaign": "Eliminar Campaña",
      "editCampaign": "Editar Campaña",
      "emptyCampaignBanner": {
        "createPosts": "Crear Publicaciones",
        "learnMore": "Saber más",
        "subtext": "Vaya, esta campaña está vacía. Crea algunas publicaciones y estarán aquí organizadas para que las revises.",
        "title": "Empecemos tu campaña"
      },
      "emptySentPosts": {
        "subtitle": "Una vez que tus publicaciones programadas sean publicadas, las verás aquí con algunos datos básicos de cómo han ido.",
        "title": "Esperando a publicaciones enviadas..."
      },
      "loadingCampaignDetails": "Cargando detalles de la campaña, como fechas y contadores, por favor espera",
      "loadingCampaignName": "Cargando nombre de la campaña, por favor espera",
      "approvals": "Aprobaciones",
      "scheduled": "Programados",
      "scheduledTitle": "Programado",
      "sent": "Enviados",
      "sentTitle": "Enviado",
      "viewCampaign": "Ver Campaña",
      "viewReport": "Ver Reporte"
    }
  },
  "default-page": {
    "connectButton": "Conecta tu Red Social",
    "defaultTitle": "Conectemos tu cuenta!"
  },
  "example": {
    "loggedIn": "Conectado...",
    "loggedOut": "Desconectado..."
  },
  "instagram-first-comment-modal": {
    "body": "Te guiaremos ahora, sólo será un momento.",
    "canRequestMorePermission": "Vamos a abrir una venta para que nos des permiso ahora.",
    "cancel": "Cancelar",
    "continue": "Continuar",
    "headline": "Parece que necesitaremos permiso para publicar un comentario en Instagram con tu cuenta. ",
    "postOnYourBehalf": "Necesitaríamos que nos des permiso para publicar comentarios en Instagram con tu cuenta. ",
    "signout": "por favor sal de tu cuenta de Facebook",
    "userNeedsLogoutSignin": "Para hacer esto, {signout}, y haz login con la cuenta que corresponde con {profileName}. Entonces podemos abrir una ventana para que nos des el permiso que necesitamos haciendo click en continuar."
  },
  "instagram-first-comment-pro-trial-modal": {
    "body": "¿Prefieres mantener los hashtags fuera de tus pies de foto en Instagram? Ahorra tiempo programándolos como primer comentario.",
    "buttonCopy": "Empieza una prueba Pro de 7 días",
    "buttonLoadingCopy": "Empezando la prueba Pro de días...",
    "buttonSubCopy": "NO HACE FALTA MÉTODO DE PAGO",
    "heading": "Actualiza a Pro para incluir un primer comentario en tus publicaciones de Instagram programadas.",
    "heading2": "Accede a todas la funcionalidades Pro ahora mismo con una prueba de 7 días.",
    "imageAlt": "Publica tu primer comentario directamente a Instagram",
    "proTrialFeatures": {
      "connectAccounts": "Conecta hasta",
      "connectAccountsBold": " 8 redes sociales",
      "firstComment": "Programa primeros comentarios en publicaciones de Instagram",
      "integrations": "Utiliza",
      "integrations2": " para conectar con Zapier, IFTTT, Quuu, Pocket, Feedly, y más.",
      "integrationsBold": " más de 60 integraciones",
      "report": "Optimiza el contenido con un",
      "reportBold": " informe de 30 días",
      "schedulePosts": "Programa hasta",
      "schedulePosts2": " por red social",
      "schedulePostsBold": " 100 publicaciones",
      "support": "Accede rápido a través de email y redes sociales",
      "supportBold": " a ayuda"
    }
  },
  "language": "Idioma",
  "onboarding-page": {
    "analyticsTab": "Analíticas",
    "awaitingTab": "Esperando aprobación",
    "company": "Empresa Foster Coffee",
    "composerInput": "¿Qué te gustaría compartir?",
    "connectButton": "Gestiona las Redes Sociales",
    "cta1": "También puedes conectar tus",
    "cta2": "y",
    "cta3": "redes sociales.",
    "ctaChannel1": "Linkedin",
    "ctaChannel2": "Pinterest",
    "currentDay": "Hoy",
    "description": "Conecta tu red social para programar tu primera publicación",
    "draftsTab": "Borradores",
    "name": "Miriam González",
    "queueTab": "Cola",
    "role": "Directora de Márketing",
    "settingsTab": "Preferencias",
    "skipStep": "O sáltate este paso",
    "testemonial": "Publish nos ayuda a mejorar el contenido que genera más interacciones.",
    "title": "¡Tu cuenta ya está lista!"
  },
  "plans-page": {
    "buttonDashboardText": "Volver al Dashboard",
    "headerText": "Elige tu plan de Buffer Publish",
    "premium": {
      "billingText": "Facturado Mensualmente",
      "buttonCurrentPlanText": "Plan Actual",
      "buttonText": "Elige Plan",
      "cost": "$65",
      "featureTooltips": [
        "",
        "",
        "Planifica, revisa y programa stories de Instagram en web y móvil.",
        "Incluye un primer comentario cuando publiques tus posts de Instagram programados",
        "Guarda una colección de hashtags para usar en tus primeros comentarios de Instagram. Reutiliza los que mejor funcionen y optimiza tu alcance.",
        "Añade enlaces únicos a publicaciones de Instagram, transformando tu perfil en una tienda online con un enlace en tu bio."
      ],
      "features": [
        "8 redes sociales",
        "2 usuarios",
        "Stories de Instagram",
        "Primer comentario en Instagram",
        "Hashtag Manager",
        "Tienda en Instagram"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$32.50",
      "plan": "premium_business",
      "soloCost": "$35",
      "soloNonProfitCost": "$17.50",
      "subtitle": "Desbloquea funcionalidades avanzadas de IG",
      "title": "Premium"
    },
    "premiumExperiment": {
      "billingText": "Facturado Mensualmente",
      "buttonCurrentPlanText": "Plan Actual",
      "buttonText": "Actualiza a Premium",
      "cost": "$65",
      "featureTooltips": [
        "",
        "Incluye un primer comentario cuando programes tus publicaciones de Instagram",
        "Etiqueta usuarios de Instagram cuando programes publicaciones de Instagram",
        "Guarda una colección de hashtags para usar en tus primeros comentarios de Instagram. Reutiliza los que mejor funcionen y optimiza tu alcance.",
        "Añade enlaces únicos a publicaciones de Instagram, transformando tu perfil en una tienda online con un enlace en tu bio.",
        "Planifica, revisa y programa stories de Instagram en web y móvil."
      ],
      "features": [
        "8 redes sociales",
        "Primer comentario en Instagram",
        "Etiquetar usuarios en Instagram",
        "Hashtag Manager",
        "Tienda en Instagram",
        "Stories de Instagram"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$32.50",
      "plan": "premium_business",
      "soloCost": "$35",
      "soloNonProfitCost": "$17.50",
      "subtitle": "Desbloquea funcionalidades avanzadas de IG",
      "title": "Premium"
    },
    "pro": {
      "billingText": "Facturado Mensualmente",
      "buttonCurrentPlanText": "Plan Actual",
      "buttonText": "Elige Plan",
      "cost": "$15",
      "featureTooltips": [
        "",
        "",
        "Incluye un primer comentario cuando programes publicaciones de Instagram"
      ],
      "features": [
        "8 redes sociales",
        "1 usuario",
        "Primer comentario en Instagram"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$7.50",
      "plan": "pro",
      "subtitle": "Empieza una estrategia en social media",
      "title": "Pro"
    },
    "proExperiment": {
      "billingText": "Facturado Mensualmente",
      "buttonCurrentPlanText": "Plan Actual",
      "buttonText": "Actualiza a Pro",
      "buttonTextDisabled": "Plan Actual",
      "cost": "$15",
      "featureTooltips": [
        "",
        "Incluye un primer comentario cuando programes publicaciones de Instagram",
        "Etiqueta usuarios de Instagram cuando programes publicaciones para Instagram"
      ],
      "features": [
        "8 redes sociales",
        "Primer comentario en Instagram",
        "Etiquetar usuarios en Instagram"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$7.50",
      "plan": "pro",
      "promoCost": "$10",
      "promoDiscount": "El descuento se aplica los primeros 3 meses",
      "promoNonProfitCost": "$5",
      "subtitle": "Empieza una estrategia en social media",
      "title": "Pro"
    },
    "promoDescription": "Por un tiempo limitado, actualiza al plan Pro y mantén tu precio actual durante 3 meses.",
    "promoHeader": "Consigue más con el nuevo Buffer Publish",
    "small": {
      "billingText": "Facturado Mensualmente",
      "buttonCurrentPlanText": "Plan Actual",
      "buttonText": "Elige Plan",
      "cost": "$99",
      "features": [
        "25 redes sociales",
        "6 usuarios",
        "Stories de Instagram",
        "Primer comentario en Instagram",
        "Hashtag Manager",
        "Tienda en Instagram"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$49.50",
      "plan": "small",
      "subtitle": "Pensado para equipos creando marca",
      "title": "Business"
    }
  },
  "tabs": {
    "queue": "Cola",
    "stories": "Stories",
    "pastReminders": "Recordatorios Pasados",
    "analytics": "Analíticas",
    "approvals": "Aprobaciones",
    "drafts": "Borradores",
    "shopGrid": "Shop Grid",
    "settings": "Opciones",
    "upgrade": "Actualizar Plan",
    "posts": "Publicaciones",
    "overview": "Visión General",
    "general": "General",
    "postingSchedule": "Calendario de Publicación",
    "reconnecting": "Reconectando...",
    "reconnect": "Reconectar"
  },
  "app-shell": {
    "preferences": "Preferencias",
    "team": "Equipo",
    "startProTrial": "Empezar prueba Pro",
    "upgradetoPro": "Subscribir al plan Pro",
    "helpCenter": "Centro de Ayuda",
    "quickHelp": "Ayuda Rápida",
    "status": "Estatus",
    "pricingAndPlans": "Precios & Planes",
    "wishlist": "Lista de Deseos"
  },
  "preferences": {
    "backToDashboard": "Volver al Dashboard",
    "menu": {
      "appsAndExtras": "Aplicaciones & Extras",
      "billing": "Facturación",
      "general": "General",
      "notifications": "Notificaciones",
      "security": "Seguridad"
    },
    "general": {
      "title": "General",
      "changePreferences": "Cambia tus preferencias generales.",
      "timeFormat": "Formato de hora",
      "hour": "horas",
      "dayToStartWeek": "Primer día de la semana",
      "sunday": "Domingo",
      "monday": "Lunes"
    },
    "security": {
      "title": "Seguridad",
      "addSecurity": "Agrega una capa adicional de seguridad a tu cuenta.",
      "password": "Contraseña",
      "passwordDescription": "Usa tu contraseña para iniciar sesión en Buffer web y aplicaciones móviles. ¡Hazlo agradable y seguro!",
      "changeYourPassword": "Cambiar contraseña",
      "twoFactorAuthentication": "Autenticación de dos factores",
      "tfaExplanation": "La autenticación de dos factores agrega una capa adicional de seguridad para tu cuenta de Buffer. Cada vez que inicies sesión en tu cuenta, después de ingresar tu nombre de usuario y contraseña, se te pedirá un segundo código de autenticación que se enviará a tu teléfono móvil por mensaje de texto o a una aplicación móvil gratuita. ",
      "method": "Método",
      "phoneNumber": "Número de teléfono",
      "recoveryCode": "Código de recuperación",
      "sms": "Mensaje de Texto",
      "authenticatorApp": "Aplicación de autenticación",
      "enableTwoFactor": "Habilitar autenticación de dos factores",
      "changeTwoFactor": "Cambiar la autenticación de dos factores",
      "sendSecutiryCodes": "¿Cómo te gustaría que te enviemos tus códigos de seguridad?",
      "textMessage": "Mensaje de Texto",
      "yourRecoveryCode": "Tu Código de Recuperación",
      "saveOneTimeCode": "Guarda este código de recuperación único",
      "recoveryCodeDescription": "Con la autenticación de dos factores, si pierdes tu teléfono, existe la posibilidad que se bloquee tu cuenta. Guarda este código en un lugar seguro para usar si no puedes iniciar sesión con tu teléfono."
    },
    "notifications": {
      "title": "Notificaciones de Correo",
      "description": "Podemos recordarte cuando uno de tus Buffer se vea un poco vacío.",
      "emptyBuffer": "Vaciar Buffer",
      "emptyBufferEmail": "Enviarme un correo electrónico cuando uno de mis Buffers esté vacío.",
      "newsletter": "Boletin informativo",
      "newsletterEmail": "Send me occasional correos electrónicos with new Buffer features and tips.",
      "updateFailures": "Fallas de Publicaciones",
      "updateFailuresEmail": "Enviarme correos electrónicos ocasionales con nuevas características y consejos de Buffer.",
      "updateSuccesses": "Publicaciones exitosas",
      "updateSuccessesEmail": "Enviarme correos electrónicos cuando una publicación se publique correctamente.",
      "weeklyDigests": "Resúmenes semanales",
      "weeklyDigestsEmail": "Enviarme correos electrónicos semanales que resuman mi actividad de publicación.",
      "approvals": "En Espera de Aprobación",
      "approvalsEmail": "Enviarme correos electrónicos cuando haya un nuevo borrador en espera de aprobación.",
      "movedBackToDrafts": "Aprobación pendiente a borrador",
      "movedBackToDraftsEmail": "Enviarme correos electrónicos cuando mi borrador se mueva de Aprobación pendiente a Borradores.",
      "celebrations": "Celebraciones",
      "celebrationsEmail": "Enviarme correos electrónicos celebrando mis logros de publicación.",
      "billing": "Facturación",
      "billingEmail": "Enviarme correos electrónicos sobre facturación y recordatorios de pago."
    },
    "appsAndExtras": {
      "title": "Buffer Applicaciones & Extras",
      "description": "Get the most out of Buffer with our mobile apps and browser extension.",
      "browserExtension": "Extensión del Navegador",
      "extensionDescription": "Nuestra extensión de navegador te permite compartir contenido mientras navegas por la web",
      "installExtension": "Instalar extension",
      "mobileApps": "Aplicaciones móviles",
      "mobileAppsDescription": "Comparte contenido y administra tu cuenta de Buffer sobre la marcha con nuestra aplicación móvil.",
      "viewOnAppleStore": "Ver en la Apple Store",
      "viewOnGooglePlay": "Ver en Google Play",
      "connectedApps": "Applicaciones Conectadas ",
      "connectedAppsDesc": "¡Aprovecha al máximo Buffer y comparte desde tu móvil, lector de noticias, blog o en cualquier lugar! ",
      "getMoreApps": "Obtén más aplicaciones →",
      "revokeAccess": "Revocar Acceso"
    }
  },
  "profile-sidebar": {
    "connectButton": "Gestionar Redes Sociales",
    "socialAccounts": "Redes sociales",
    "connectInstagram": "Conectar Instagram",
    "connectFacebook": "Conectar Facebook",
    "connectTwitter": "Conectar Twitter",
    "searchProfiles": "Buscar Perfiles",
    "noProfilesFound": "No se encontraron perfiles"
  },
  "profiles-disconnected-banner": {
    "body": "Por favor, asegúrate de que estás logueado/a en esta cuenta en la misma red social y solucionaremos esto en un momento.",
    "cta": "Reconectar Cuenta",
    "extraMessage": {
      "instagram": "Debido a cambios recientes en la API de Instagram, tus perfiles personales de Instagram necesitan ser reconectados."
    },
    "headline": "Ups, hemos perdido acceso a esta cuenta. ¡Vamos a reconectarla!"
  },
  "profiles-disconnected-modal": {
    "body1": " Hemos perdido accesso a las siguientes redes sociales, para volver a publicar en ellas, encestamos que las reconectes.",
    "body2": "Importante: necesitas estar logueado/a en la misma cuenta de la red social para reconectarla correctamente.",
    "cta": "Reconectar",
    "extraMessage": {
      "instagram": "Debido a cambios recientes en la API de Instagram, tus perfiles personales de Instagram necesitan ser reconectados."
    },
    "headline": "Hemos perdido el acceso a algunas de tus redes sociales",
    "reconnecting": "Por favor, espera..."
  },
  "story-group-composer": {
    "addMedia": "Añadir Archivos",
    "addNote": "Añadir Nota",
    "cancelNoteButton": "Atrás",
    "noteImageAlt": "Archivos de la story de Instagram",
    "notePlaceholder": "Añade tu pie de foto o nota para ti",
    "noteSubText": "Cuando sea el momento de publicar, podrás copiar y pegar tu nota en Instagram.",
    "previewButton": "Previsualizar",
    "processingVideo": "Procesando video",
    "saveNoteButton": "Guardar Nota",
    "scheduleButton": "Programar Story",
    "scheduleLoadingButton": "Programando Story...",
    "shareNowButton": "Publicar Ahora"
  },
  "story-group-queue": {
    "bannerMobileTagText": "Vaya...parece que no tienes la última versión de la aplicación móvil de Buffer. Descárgatela ahora para que puedas compartir esta story!",
    "inputPlaceholder": "¿Qué te gustaría añadir a tu Story?",
    "mobileTagText": "Oh! parece que no tienes la última versión de la aplicación móvil de Buffer.  Descárgatela ahora para empezar a usar Stories",
    "reminderLinkText2": "Recordatorio ",
    "reminderText1": "Cuando sea el momento de publicar tu Story, te enviaremos un ",
    "reminderText3": "a tu móvil.",
    "start": {
      "learnMore": "Saber Más",
      "setReminders": "Configura Recordatorios Para Empezar",
      "step1Description": "Debido a las limitaciones de Instagram, las Stories no pueden ser publicadas directamente. Un Recordatorio es una notificación de la aplicación móvil de Buffer.",
      "step1Title": "Configura Recordatorios",
      "step2Description": "Planifica tu contenido y crea borradores para los textos. Después, elige la fecha y hora en la que te gustaría compartirlo con tus seguidores.",
      "step2Title": "Crea Tu Story",
      "step3Description": "Cuando llegue el momento programado, Buffer te mandará un Recordatorio. Previsualízalo en el móvil y toca para abrirlo en Instagram.",
      "step3Title": "Comparte tu Story",
      "title": "Empieza con Stories para Instagram"
    }
  },
  "story-preview": {
    "addNote": "Añadir Nota",
    "cancel": "Cancelar",
    "editNote": "Editar Nota",
    "noteExplanation": "Cuando llegue el momento de publicar, podrás copiar y pegar tu nota en Instagram.",
    "notePlaceholder": "Añade tu pie de foto o nota para tí",
    "noteTitle": "Nota",
    "saveNote": "Guardar Nota"
  },
  "upload-zone": {
    "buttonTitle": "Subir archivo multimedia",
    "invalidFileSize": "No podemos subir \"{fileName}\" porque es muy grande: sólo podemos manejar archivos de ese tipo de hasta {formattedMaxSize}. ¿Podrías intentar con un archivo más pequeño?",
    "tooSmallFileSize": "No podemos subir \"{fileName}\" porque es muy pequeño: esta red social puede manejar archivos de ese tipo desde {formattedMinSize}. ¿Podrías intentar con un archivo más grande?",
    "invalidFormatCantOneOfFiles": "No podemos usar uno de los tipos de archivos seleccionados. ¿Podrías intentar con algunos de los siguientes?: {acceptedFilesText}",
    "invalidFormatCantSingleFile": "No podemos usar ese tipo de archivo. ¿Podrías intentar con algunos de los siguientes?: {acceptedFilesText}?",
    "invalidFormatCantUseAnyFiles": "No podemos usar ninguno de los archivos seleccionados. ¿Podrías intentar con algunos de los siguientes?: {acceptedFilesText}",
    "invalidFormatCantUseSomeFiles": "No podemos usar algunos de los tipos de archivos seleccionados. ¿Podrías intentar con algunos de los siguientes?: {acceptedFilesText}"
  },
  "user-tags": {
    "btnCancel": "Cancelar",
    "btnSave": "Guardar",
    "footerText": "Las limitaciones en Instagram no nos dejan buscar por nombres de usuario y etiquetar usuarios privados.",
    "imgAltText": "Imagen para etiquetar usuarios",
    "inputBtnAddTag": "Añadir Etiqueta",
    "inputBtnCancel": "Cancelar",
    "inputBtnLabel": "Añadir Etiqueta",
    "inputLabel": "Usuario en Instagram",
    "maxLimitText": "Límite de 20 etiquetas alcanzado.",
    "placeholder": "nombre de usuario",
    "rightHeader": "Etiqueta Usuarios",
    "rightHeaderSubtext": "Haz click donde quieras en la imagen para etiquetar un usuario público.",
    "tooltip": "Ver perfil",
    "usernameError": "Ups! Ya has etiquetado a ese usuario"
  }
}
